import { useEffect, useState, useRef, useCallback } from 'react';
import moment from 'moment';

import './style.scss';

const calculateDuration = eventTime => moment.duration(Math.max(eventTime - (Math.floor(Date.now() / 1000)), 0), 'seconds');

const CountDownTimer = ({
    dateTime,
    views = ['months', 'days', 'hours', 'minutes', 'seconds'],
    onEndTime,
    isUTC = false,
    id = null,
    isEmphasized = false,
    ...rest
}) => {
    const timerRef = useRef(0);

    const [duration, setDuration] = useState(calculateDuration(moment.utc(dateTime).local().unix()));
    const [isValidDate, setIsValidDate] = useState(true);
    const [months, setMonths] = useState(0);
    const [days, setDays] = useState(0);
    const [hours, setHours] = useState(0);
    const [minutes, setMinutes] = useState(0);
    const [seconds, setSeconds] = useState(0);

    useEffect(() => {
        let mounted = true;

        if (!moment(dateTime).isValid()) {
            setIsValidDate(false);
        } else {
            setIsValidDate(true);
            timerRef.current = setInterval(timerCallback, 1000);
        }


        return () => {
            mounted = false;
            clearInterval(timerRef.current);
        };
    }, [dateTime]);

    const timerCallback = useCallback(() => {

        let time = '';
        if (dateTime && moment.isMoment(dateTime) && dateTime.isUTC()) {
            time = moment.utc(dateTime).local().unix();
        } else {
            if (isUTC) {
                time = moment.utc(dateTime).local().unix();
            } else {
                time = moment(dateTime).unix();
            }
        }

        setDuration(calculateDuration(time));
    }, [dateTime]);

    useEffect(() => {
        let mounted = true;

        if (duration.years() == 0 && duration.months() == 0 && duration.days() == 0 && duration.hours() == 0 && duration.minutes() == 0 && duration.seconds() == 0) {
            clearInterval(timerRef.current);
            onEndTime(id);
        }

        return () => {
            mounted = false;
        };
    }, [duration]);

    useEffect(() => {
        setMonths((duration.years() * 12) + duration.months());
        setDays(duration.days());
        setHours(duration.hours());
        setMinutes(duration.minutes());
        setSeconds(duration.seconds());

        return () => {
        };
    }, [duration]);


    if (!isValidDate) {
        return '';
    }

    return <>
        {
            isEmphasized
                ? <div className='timer lg' {...rest}>
                    {
                        months > 0 && <div className='timer__container__lg'>
                            <span className='timer__value'>{months}</span>
                            <span className='timer__label'>
                                {
                                    months === 1 ? 'mth' : 'mths'
                                }
                            </span>
                        </div>
                    }
                    {
                        days > 0 && <div className='timer__container__lg'>
                            <span className='timer__value'>{days}</span>
                            <span className='timer__label'>
                                {
                                    days === 1 ? 'day' : 'days'
                                }
                            </span>
                        </div>
                    }
                    {
                        hours > 0 && <div className='timer__container__lg'>
                            <span className='timer__value'>{hours}</span>
                            <span className='timer__label'>
                                {
                                    hours === 1 ? 'hr' : 'hrs'
                                }
                            </span>
                        </div>
                    }
                    {
                        minutes > 0 && <div className='timer__container__lg'>
                            <span className='timer__value'>{minutes}</span>
                            <span className='timer__label'>min</span>
                        </div>
                    }
                    {
                        <div className='timer__container__lg'>
                            <span className='timer__value'>{seconds}</span>
                            <span className='timer__label'>sec</span>
                        </div>
                    }
                </div>
                : <div className='timer' {...rest}>
                    {
                        months > 0 && views.includes('months') && <div className='timer__container'>
                            <span className='timer__value'>{months}</span>
                            <span className='timer__label'>
                                {
                                    months > 1 ? 'mths' : 'mth'
                                }
                            </span>
                        </div>
                    }
                    {
                        days > 0 && views.includes('days') && <div className='timer__container'>
                            <span className='timer__value'>{days}</span>
                            <span className='timer__label'>
                                {
                                    days > 1 ? 'days' : 'day'
                                }
                            </span>
                        </div>
                    }
                    {
                        hours > 0 && views.includes('hours') && <div className='timer__container'>
                            <span className='timer__value'>{hours}</span>
                            <span className='timer__label'>
                                {
                                    hours > 1 ? 'hrs' : 'hr'
                                }
                            </span>
                        </div>
                    }
                    {
                        minutes > 0 && views.includes('minutes') && <div className='timer__container'>
                            <span className='timer__value'>{minutes}</span>
                            <span className='timer__label'>min</span>
                        </div>
                    }
                    {
                        views.includes('seconds') && <div className='timer__container'>
                            <span className='timer__value'>{seconds}</span>
                            <span className='timer__label'>sec</span>
                        </div>
                    }
                </div>
        }
    </>;
};

export default CountDownTimer;